/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Spotting_Event_Group_LabelInputs */



/**
* | output |
* | --- |
* | "Spotting List Event Group" |
*
* @param {Ccsl_Export_Spotting_Event_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_spotting_event_group_label = /** @type {((inputs?: Ccsl_Export_Spotting_Event_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Spotting_Event_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'evenements de la liste de reperage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsgruppe „Spotting List“")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di eventi della lista di avvistamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа мероприятий «Список наблюдений»")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de eventos de lista de avistamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("观测列表活动组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スポッティングリストイベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पॉटिंग लिस्ट इवेंट ग्रुप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos da Lista de Observação")
	return /** @type {LocalizedString} */ ("Spotting List Event Group")
});